import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const CreditreportAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		institution: yup.string().nullable().label($t('institution')),
		mfdate: yup.string().nullable().label($t('mfdate')),
		requestpurpose: yup.string().nullable().label($t('requestpurpose')),
		amount: yup.string().nullable().label($t('amount')),
		accountnumber: yup.string().nullable().label($t('accountnumber')),
		currentbalance: yup.string().nullable().label($t('currentbalance')),
		institutions: yup.string().nullable().label($t('institutions')),
		pastdueamount: yup.string().nullable().label($t('pastdueamount')),
		disbursedamount: yup.string().nullable().label($t('disbursedamount')),
		loancategory: yup.string().nullable().label($t('loancategory')),
		loanpurpose: yup.string().nullable().label($t('loanpurpose')),
		sanctionamount: yup.string().nullable().label($t('sanctionamount')),
		lastpaymentdate: yup.string().nullable().label($t('lastpaymentdate')),
		datereported: yup.string().nullable().label($t('datereported')),
		dateopened: yup.string().nullable().label($t('dateopened')),
		loancycleid: yup.string().nullable().label($t('loancycleid')),
		datesanctioned: yup.string().nullable().label($t('datesanctioned')),
		report_id: yup.number().required().label($t('reportId')),
		userid: yup.number().nullable().label($t('userid')),
		microfinance_risk_score: yup.string().nullable().label($t('microfinanceRiskScore')),
		ers_score: yup.string().nullable().label($t('ersScore')),
		accountstatus: yup.string().nullable().label($t('accountstatus')),
		repaymenttenure: yup.string().nullable().label($t('repaymenttenure'))
	});
	
	//form default values
	const formDefaultValues = {
		institution: '', 
		mfdate: new Date(), 
		requestpurpose: '', 
		amount: '', 
		accountnumber: '', 
		currentbalance: '', 
		institutions: '', 
		pastdueamount: '', 
		disbursedamount: '', 
		loancategory: '', 
		loanpurpose: '', 
		sanctionamount: '', 
		lastpaymentdate: new Date(), 
		datereported: new Date(), 
		dateopened: new Date(), 
		loancycleid: '', 
		datesanctioned: new Date(), 
		report_id: '', 
		userid: '', 
		microfinance_risk_score: '', 
		ers_score: '', 
		accountstatus: '', 
		repaymenttenure: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/creditreport`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="CreditreportAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewCreditReport')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('institution')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="institution"  onChange={formik.handleChange}  value={formik.values.institution}   label={$t('institution')} type="text" placeholder={$t('enterInstitution')}        className={inputClassName(formik?.errors?.institution)} />
                                                <ErrorMessage name="institution" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mfdate')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="mfdate" value={formik.values.mfdate} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.mfdate)}        />
                                                <ErrorMessage name="mfdate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('requestpurpose')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="requestpurpose"  onChange={formik.handleChange}  value={formik.values.requestpurpose}   label={$t('requestpurpose')} type="text" placeholder={$t('enterRequestpurpose')}        className={inputClassName(formik?.errors?.requestpurpose)} />
                                                <ErrorMessage name="requestpurpose" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('amount')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="amount"  onChange={formik.handleChange}  value={formik.values.amount}   label={$t('amount')} type="text" placeholder={$t('enterAmount')}        className={inputClassName(formik?.errors?.amount)} />
                                                <ErrorMessage name="amount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('accountnumber')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="accountnumber"  onChange={formik.handleChange}  value={formik.values.accountnumber}   label={$t('accountnumber')} type="text" placeholder={$t('enterAccountnumber')}        className={inputClassName(formik?.errors?.accountnumber)} />
                                                <ErrorMessage name="accountnumber" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('currentbalance')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="currentbalance"  onChange={formik.handleChange}  value={formik.values.currentbalance}   label={$t('currentbalance')} type="text" placeholder={$t('enterCurrentbalance')}        className={inputClassName(formik?.errors?.currentbalance)} />
                                                <ErrorMessage name="currentbalance" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('institutions')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="institutions"  onChange={formik.handleChange}  value={formik.values.institutions}   label={$t('institutions')} type="text" placeholder={$t('enterInstitutions')}        className={inputClassName(formik?.errors?.institutions)} />
                                                <ErrorMessage name="institutions" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('pastdueamount')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pastdueamount"  onChange={formik.handleChange}  value={formik.values.pastdueamount}   label={$t('pastdueamount')} type="text" placeholder={$t('enterPastdueamount')}        className={inputClassName(formik?.errors?.pastdueamount)} />
                                                <ErrorMessage name="pastdueamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('disbursedamount')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="disbursedamount"  onChange={formik.handleChange}  value={formik.values.disbursedamount}   label={$t('disbursedamount')} type="text" placeholder={$t('enterDisbursedamount')}        className={inputClassName(formik?.errors?.disbursedamount)} />
                                                <ErrorMessage name="disbursedamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('loancategory')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="loancategory"  onChange={formik.handleChange}  value={formik.values.loancategory}   label={$t('loancategory')} type="text" placeholder={$t('enterLoancategory')}        className={inputClassName(formik?.errors?.loancategory)} />
                                                <ErrorMessage name="loancategory" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('loanpurpose')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="loanpurpose"  onChange={formik.handleChange}  value={formik.values.loanpurpose}   label={$t('loanpurpose')} type="text" placeholder={$t('enterLoanpurpose')}        className={inputClassName(formik?.errors?.loanpurpose)} />
                                                <ErrorMessage name="loanpurpose" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('sanctionamount')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="sanctionamount"  onChange={formik.handleChange}  value={formik.values.sanctionamount}   label={$t('sanctionamount')} type="text" placeholder={$t('enterSanctionamount')}        className={inputClassName(formik?.errors?.sanctionamount)} />
                                                <ErrorMessage name="sanctionamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('lastpaymentdate')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="lastpaymentdate" value={formik.values.lastpaymentdate} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.lastpaymentdate)}        />
                                                <ErrorMessage name="lastpaymentdate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('datereported')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="datereported" value={formik.values.datereported} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.datereported)}        />
                                                <ErrorMessage name="datereported" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('dateopened')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="dateopened" value={formik.values.dateopened} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.dateopened)}        />
                                                <ErrorMessage name="dateopened" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('loancycleid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="loancycleid"  onChange={formik.handleChange}  value={formik.values.loancycleid}   label={$t('loancycleid')} type="text" placeholder={$t('enterLoancycleid')}        className={inputClassName(formik?.errors?.loancycleid)} />
                                                <ErrorMessage name="loancycleid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('datesanctioned')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="datesanctioned" value={formik.values.datesanctioned} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.datesanctioned)}        />
                                                <ErrorMessage name="datesanctioned" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('reportId')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="report_id"  onChange={formik.handleChange}  value={formik.values.report_id}   label={$t('reportId')} type="number" placeholder={$t('enterReportId')}  min={0}  step="any"    className={inputClassName(formik?.errors?.report_id)} />
                                                <ErrorMessage name="report_id" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('userid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="userid"  onChange={formik.handleChange}  value={formik.values.userid}   label={$t('userid')} type="number" placeholder={$t('enterUserid')}  min={0}  step="any"    className={inputClassName(formik?.errors?.userid)} />
                                                <ErrorMessage name="userid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('microfinanceRiskScore')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="microfinance_risk_score"  onChange={formik.handleChange}  value={formik.values.microfinance_risk_score}   label={$t('microfinanceRiskScore')} type="text" placeholder={$t('enterMicrofinanceRiskScore')}        className={inputClassName(formik?.errors?.microfinance_risk_score)} />
                                                <ErrorMessage name="microfinance_risk_score" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('ersScore')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="ers_score"  onChange={formik.handleChange}  value={formik.values.ers_score}   label={$t('ersScore')} type="text" placeholder={$t('enterErsScore')}        className={inputClassName(formik?.errors?.ers_score)} />
                                                <ErrorMessage name="ers_score" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('accountstatus')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="accountstatus"  onChange={formik.handleChange}  value={formik.values.accountstatus}   label={$t('accountstatus')} type="text" placeholder={$t('enterAccountstatus')}        className={inputClassName(formik?.errors?.accountstatus)} />
                                                <ErrorMessage name="accountstatus" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('repaymenttenure')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="repaymenttenure"  onChange={formik.handleChange}  value={formik.values.repaymenttenure}   label={$t('repaymenttenure')} type="text" placeholder={$t('enterRepaymenttenure')}        className={inputClassName(formik?.errors?.repaymenttenure)} />
                                                <ErrorMessage name="repaymenttenure" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
CreditreportAddPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'creditreport',
	apiPath: 'creditreport/add',
	routeName: 'creditreportadd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default CreditreportAddPage;
